import { render } from "./RestrictedAreas.htm?vue&type=template&id=74dd6b62&scoped=true&ts=true"
import script from "./RestrictedAreas.vue?vue&type=script&lang=ts"
export * from "./RestrictedAreas.vue?vue&type=script&lang=ts"

import "./RestrictedAreas.scss?vue&type=style&index=0&id=74dd6b62&lang=scss&scoped=true"

import exportComponent from "C:\\Projets\\FIFA\\Dev\\GIS-Dispatcher-Front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74dd6b62"]])

export default __exports__